/**
 * @description prefiusso per l'id del fieldset
 */
export const FORM_CONTROL_ID_PREFIX = 'input-';

/**
 * @description prefisso per id del fieldset
 */
export const FORM_FIELDSET_ID_PREFIX = 'fset-';
